import { ICampaign, IDefaultTargetAcos } from "../../types/sponsoredProducts"
import { stateByCampaignId } from "../../../../types/customers"
import { IConditions } from "../../../../types/limitedCPC"

export enum SponsoredProductActionType {
  FETCH_SPONSORED_PRODUCTS = "SP_SKC/FETCH_SPONSORED_PRODUCTS",
  FETCH_SPONSORED_PRODUCTS_SUCCESS = "SP_SKC/FETCH_SPONSORED_PRODUCTS_SUCCESS",
  FETCH_SPONSORED_PRODUCTS_ERROR = "SP_SKC/FETCH_SPONSORED_PRODUCTS_ERROR",
  SET_CAMPAIGN_DATA = "SP_SKC/SET_CAMPAIGN_DATA",
  CHANGE_CAMPAIGN = "SP_SKC/CHANGE_CAMPAIGN",
  FETCH_CAMPAIGN_STATE_SUCCESS = "SP_SKC/FETCH_CAMPAIGN_STATE_SUCCESS",
  FETCH_CAMPAIGN_STATE_ERROR = "SP_SKC/FETCH_CAMPAIGN_STATE_ERROR",
  SET_CAMPAIGNS = "SP_SKC/SET_CAMPAIGNS",
}

interface FetchSponsoredProducts {
  type: SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS
}

interface FetchSponsoredProductsSuccess {
  type: SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS_SUCCESS
  payload: campaignData
}

interface FetchSponsoredProductsError {
  type: SponsoredProductActionType.FETCH_SPONSORED_PRODUCTS_ERROR
  payload: string
}

interface ChangeCampaign {
  type: SponsoredProductActionType.CHANGE_CAMPAIGN
  payload: ICampaign
}

interface SetCampaignData {
  type: SponsoredProductActionType.SET_CAMPAIGN_DATA
  payload: any[]
}

interface FetchCampaignStateSuccess {
  type: SponsoredProductActionType.FETCH_CAMPAIGN_STATE_SUCCESS
  payload: stateByCampaignId[]
}

interface FetchCampaignStateError {
  type: SponsoredProductActionType.FETCH_CAMPAIGN_STATE_ERROR
  payload: string
}

interface SetCampaigns {
  type: SponsoredProductActionType.SET_CAMPAIGNS
  payload: ICampaign[]
}

type getAOVData = {
  customerId: string
  profileId: string
  aovs: {
    _id: string
    campaignName: string
    value: number
    cogs: number
  }[]
}

type targetAcos = {
  TOS_ACOS: string
  PP_ACOS: string
  ROS_ACOS: string
}

export type SponsoredProductAction =
  | FetchSponsoredProducts
  | FetchSponsoredProductsSuccess
  | FetchSponsoredProductsError
  | SetCampaignData
  | ChangeCampaign
  | FetchCampaignStateSuccess
  | FetchCampaignStateError
  | SetCampaigns

export type campaignData = {
  campaigns: ICampaign[]
  defaultTargetAcos: IDefaultTargetAcos[]
  limitedCPCValue: {
    conditions: IConditions[]
  }
  targetAcos: targetAcos[]
  getAOVData: getAOVData
  TOSPercentage: number
  PPPercentage: number
  ROSPercentage: number
  ABPercentage: number
  ADPercentage: number
  currentPageNo: number
  defaultBid: number
  defaultOrder: number
  limitValue: number
  maxTargetCPC: number
  minTargetCPC: number
  lastDateWithoutData: string
  updatedCompanyIdsToday: string[]
  excludeAdjustedCampaign: boolean
}

export interface SponsoredProductState {
  campaignData: campaignData
  isLoading: boolean
  error: null | string
}
